import { render } from "./HeaderView.vue?vue&type=template&id=0deeb55c&scoped=true"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=0deeb55c&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0deeb55c"]])

export default __exports__